import type { AppRouter } from '@repo/trpc';
import { QueryClient } from '@tanstack/react-query';
import { createTRPCClient, httpBatchLink, httpBatchStreamLink, splitLink, TRPCClient } from '@trpc/client';
import { createTRPCOptionsProxy } from '@trpc/tanstack-react-query';
import superJSON from 'superjson';

const LOCAL_API = import.meta.env.VITE_API_URL || '';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5000,
    },
  },
});


export function getBaseAPIURL() {
  if (LOCAL_API != '') {
    return LOCAL_API
  }
  return 'https://api.getzube.com/api'
}

export function getAPIURL() {
  return `${getBaseAPIURL()}/trpc`
}

// Create the tRPC client
export const baseTrpcClient: TRPCClient<AppRouter> = createTRPCClient<AppRouter>({
  links: [
    splitLink({
      // Route streaming endpoints to httpBatchStreamLink
      // Matches: any path with 'stream' OR the NLQ query which is an async generator
      condition: (op) => op.path.includes('stream') || op.path === 'zubeAgents.insights.executeNaturalLanguageQuery',
      true: httpBatchStreamLink({
        url: getAPIURL(),
        async headers() {
          const headers: Record<string, string> = {
            'trpc-accept': 'application/jsonl', // Required for streaming
          };
          const personaUserId = localStorage.getItem('persona_user_id');
          if (personaUserId) {
            headers['x-persona-user-id'] = personaUserId;
          }
          return headers;
        },
        transformer: superJSON,
        fetch: (url, options) => {
          return fetch(url, {
            ...options,
            credentials: 'include', // Include cookies in requests
          });
        },
      }),
      false: httpBatchLink({
        url: getAPIURL(),
        async headers() {
          const headers: Record<string, string> = {};
          const personaUserId = localStorage.getItem('persona_user_id');
          if (personaUserId) {
            headers['x-persona-user-id'] = personaUserId;
          }
          return headers;
        },
        transformer: superJSON,
        fetch: (url, options) => {
          return fetch(url, {
            ...options,
            credentials: 'include', // Include cookies in requests
          });
        },
      }),
    }),
  ],
});

/**
 * Export the tRPC proxy that provides type-safe query and mutation factories
 * for use with TanStack Query
 * https://trpc.io/docs/client/tanstack-react-query/setup
 */
export const trpc: ReturnType<typeof createTRPCOptionsProxy<AppRouter>> = createTRPCOptionsProxy<AppRouter>({
  client: baseTrpcClient,
  queryClient: () => queryClient,
});